import axios from "axios";
import store from '../store'
import router from '../apps/iws/router'

const axiosBase = axios.create({
    baseURL: process.env.VUE_APP_URL
})

//请求传header
axiosBase.interceptors.request.use(config=>{
    if(sessionStorage.getItem('token') && sessionStorage.getItem('username')){
        config.headers.Authorization = sessionStorage.getItem('token');
        // config.headers.username = sessionStorage.getItem('username');
    }
    else{
        router.push({path:'/'});
    }
    return config;
}, error=>{
    return Promise.reject(error);
})

axiosBase.interceptors.response.use(response=>{
    if(response != undefined && response != null && response.data != undefined && response.data != null && response.data.code != 200 && response.data.msg != undefined && (response.data.msg.indexOf('ExpiredSignature') != -1 || response.data.msg.indexOf('认证失败，请先登录') !=-1)){
        let token = sessionStorage.getItem('token');
        if(token != undefined && token != ''){
            store.dispatch('login/logout', {'token': sessionStorage.getItem('token')})
            .then(res=>{
                router.push({path:'/'});
            })
        }
        
        store.commit('login/setIsLogin',false);
        store.commit('login/setUserToken','');
        store.commit('login/setUsername','');
        store.commit('project/setProjectList', []);
        sessionStorage.removeItem('username');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('homeSelectMenu');
        sessionStorage.removeItem('sceneManageChild');
        sessionStorage.removeItem('isLogin');
        sessionStorage.removeItem('userAvatar');
        sessionStorage.removeItem('selectProject');
        sessionStorage.removeItem('tabPage');
        sessionStorage.removeItem('selectGroup');
        router.push({path:'/'});
        
        return Promise.reject(response.data.msg);
    }
    else{
        return Promise.resolve(response);
    }
}, error=>{
    return Promise.reject(error);
})

export default axiosBase